module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$hydrowareSecurityJS.canDisplay_A('chemicalrecord') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Readings and Tasks"
    }
  })], 1) : _c('div', {
    staticClass: "col-xs-12"
  }, [(this.$hydrowareCommonJS.showInnerPageHeading) ? _c('div', {
    attrs: {
      "id": "list_record"
    }
  }, [_c('div', {
    staticClass: "row x_title"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-10 col-xs-10"
  }, [_c('h2', {
    staticClass: "x_title",
    staticStyle: {
      "border-bottom": "inherit"
    }
  }, [_c('b', [_vm._v("Manage Readings and Tasks " + _vm._s(_vm.headerLocationName))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listRecord),
      expression: "listRecord"
    }]
  }, [_c('v-client-table', {
    staticClass: "hydroware-table",
    attrs: {
      "data": _vm.chemicalRecords,
      "columns": _vm.Chemicalcolumns,
      "options": _vm.optionstable
    },
    scopedSlots: _vm._u([{
      key: "AddedOn",
      fn: function(props) {
        return [_vm._v("\r\n          " + _vm._s(_vm._f("fdate1")(props.row.UpdatedOn ? props.row.UpdatedOn : props.row.AddedOn)) + "\r\n        ")]
      }
    }, {
      key: "IsAlertRange",
      fn: function(props) {
        return [_vm._v("\r\n          " + _vm._s(props.row.IsInRange ? 'Yes' : 'No') + "\r\n        ")]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-viewOrEdit-button', {
          attrs: {
            "EV": _vm.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('chemicalrecord')
          },
          on: {
            "click": function($event) {
              return _vm.GetChemicalRecordDetails(props.row.Id)
            }
          }
        }), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDelete_A('chemicalrecord')) ? _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.del(props.row.Id)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('chemicalrecord')) ? _c('hydroware-add-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isediting),
      expression: "!isediting"
    }],
    attrs: {
      "slot": "afterLimit"
    },
    on: {
      "click": function($event) {
        return _vm.AddChemicals()
      }
    },
    slot: "afterLimit"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addRecord),
      expression: "addRecord"
    }],
    attrs: {
      "id": "add_record"
    }
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-10 col-xs-10"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\r\n          Template: " + _vm._s(!_vm.templateName ? _vm.checklistName.Name : '') + " " + _vm._s(_vm.templateName ? _vm.templateName : '') + "\r\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "inner_title_buttons"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.addRecord && _vm.addRecordbutton && !_vm.qid && (_vm.$hydrowareSecurityJS.canAdd_A('chemicalrecord'))) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddChemicalRecord('templateForm')
      }
    }
  }, [_vm._v("\r\n              Save\r\n            ")]) : _vm._e(), _vm._v(" "), (_vm.addRecord && !_vm.addRecordbutton && !_vm.qid && (_vm.$hydrowareSecurityJS.canEdit_A('chemicalrecord'))) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.UpdateChemicalRecord
    }
  }, [_vm._v("\r\n              Update\r\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.isDashboardView) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rediectToDashboard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Dashboard ")])]) : _vm._e(), _vm._v(" "), (_vm.addRecord && !_vm.qid) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Log List")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-form', {
    ref: "templateForm",
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('chemicalrecord', _vm.isAddingOrEditing),
      "model": _vm.templateForm,
      "rules": _vm.rules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.editableTabsValue),
      callback: function($$v) {
        _vm.editableTabsValue = $$v
      },
      expression: "editableTabsValue"
    }
  }, _vm._l((_vm.editableTabs.Pools), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.PoolName,
        "name": item.name
      }
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12"
    }, [_c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('hydroware-container-with-heading', {
      attrs: {
        "title": "Readings"
      }
    }, [_c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('el-form-item', _vm._l((_vm.templateForm.TemplateReadings), function(reading, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (reading.PoolId == item.PoolId),
          expression: "reading.PoolId == item.PoolId"
        }],
        key: reading.PoolId,
        staticClass: "col-xs-12"
      }, [_c('el-form-item', {
        attrs: {
          "prop": 'TemplateReadings.' + index,
          "rules": [{
            validator: _vm.validateReading,
            trigger: 'blur'
          }]
        }
      }, [_c('el-input', {
        staticStyle: {
          "float": "left",
          "width": "100px"
        },
        model: {
          value: (reading.LogTemplateReadingValue),
          callback: function($$v) {
            _vm.$set(reading, "LogTemplateReadingValue", $$v)
          },
          expression: "reading.LogTemplateReadingValue"
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "el-form-item__label ",
        staticStyle: {
          "margin-left": "8px",
          "font-size": "14px",
          "color": "inherit!important"
        }
      }, [_vm._v("\r\n                              " + _vm._s(reading.LogName) + " " + _vm._s(reading.UoM ? '( ' + reading.UoM + ' )' : '') + "\r\n                            ")])], 1)], 1)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.templateForm.TemplateNotes[index].PoolId == item.PoolId),
        expression: "templateForm.TemplateNotes[index].PoolId == item.PoolId"
      }]
    }, [_c('label', {
      staticClass: "el-form-item__label col-xs-12",
      staticStyle: {
        "font-size": "14px",
        "color": "inherit!important"
      }
    }, [_vm._v("\r\n                            NOTES:\r\n                          ")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 5
      },
      model: {
        value: (_vm.templateForm.TemplateNotes[index].ReadingsNotes),
        callback: function($$v) {
          _vm.$set(_vm.templateForm.TemplateNotes[index], "ReadingsNotes", $$v)
        },
        expression: "templateForm.TemplateNotes[index].ReadingsNotes"
      }
    })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('hydroware-container-with-heading', {
      attrs: {
        "title": "Maintenance"
      }
    }, [_c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('el-form-item', [_vm._l((_vm.templateForm.TemplateMaintenance), function(maint, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (maint.PoolId == item.PoolId),
          expression: "maint.PoolId == item.PoolId"
        }],
        key: maint.PoolId,
        staticStyle: {
          "margin-top": "6px",
          "margin-bottom": "6px"
        }
      }, [_c('label', {
        staticClass: "el-form-item__label col-xs-12",
        staticStyle: {
          "margin-left": "8px",
          "font-size": "14px",
          "color": "inherit !important"
        }
      }, [_vm._v("\r\n                            " + _vm._s(maint.MaintenanceName) + "\r\n                          ")]), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "prop": 'TemplateMaintenance.' + index,
          "rules": [{
            validator: _vm.validateMaintenance,
            trigger: 'blur'
          }]
        }
      }, [_c('div', {
        staticStyle: {
          "display": "table-cell"
        }
      }, [_c('hydroware-success-failure-buttons', {
        on: {
          "input": function($event) {
            return _vm.maintCheckboxChanged(maint)
          }
        },
        model: {
          value: (maint.LogTemplateMaintenanceValue),
          callback: function($$v) {
            _vm.$set(maint, "LogTemplateMaintenanceValue", $$v)
          },
          expression: "maint.LogTemplateMaintenanceValue"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "table-cell",
          "width": "100%",
          "position": "relative",
          "top": "-5px"
        }
      }, [_c('el-input', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "id": maint.LogTemplateMaintenanceId
        },
        model: {
          value: (maint.UserComment),
          callback: function($$v) {
            _vm.$set(maint, "UserComment", $$v)
          },
          expression: "maint.UserComment"
        }
      })], 1)])], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.templateForm.TemplateNotes[index].PoolId == item.PoolId),
        expression: "templateForm.TemplateNotes[index].PoolId == item.PoolId"
      }]
    }, [_c('label', {
      staticClass: "el-form-item__label col-xs-12",
      staticStyle: {
        "font-size": "14px",
        "color": "inherit!important"
      }
    }, [_vm._v("\r\n                              NOTES:\r\n                            ")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 5
      },
      model: {
        value: (_vm.templateForm.TemplateNotes[index].MaintenanceNotes),
        callback: function($$v) {
          _vm.$set(_vm.templateForm.TemplateNotes[index], "MaintenanceNotes", $$v)
        },
        expression: "templateForm.TemplateNotes[index].MaintenanceNotes"
      }
    })], 1)], 1)], 2)], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('hydroware-container-with-heading', {
      attrs: {
        "title": "Tasks"
      }
    }, [_c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('el-form-item', [_vm._l((_vm.templateForm.TemplateTasks), function(task, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (task.PoolId == item.PoolId),
          expression: "task.PoolId == item.PoolId"
        }],
        key: task.PoolId,
        staticStyle: {
          "margin-top": "6px",
          "margin-bottom": "6px"
        }
      }, [_c('label', {
        staticClass: "el-form-item__label col-xs-12",
        staticStyle: {
          "margin-left": "8px",
          "font-size": "14px",
          "color": "inherit !important"
        }
      }, [_vm._v("\r\n                            " + _vm._s(task.TaskName) + "\r\n                          ")]), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "prop": 'TemplateTasks.' + index,
          "rules": [{
            validator: _vm.validateTask,
            trigger: 'blur'
          }]
        }
      }, [_c('div', {
        staticStyle: {
          "display": "table-cell"
        }
      }, [_c('hydroware-success-failure-buttons', {
        on: {
          "input": function($event) {
            return _vm.taskCheckboxChanged(task)
          }
        },
        model: {
          value: (task.LogTemplateTaskValue),
          callback: function($$v) {
            _vm.$set(task, "LogTemplateTaskValue", $$v)
          },
          expression: "task.LogTemplateTaskValue"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "table-cell",
          "width": "100%",
          "position": "relative",
          "top": "-5px"
        }
      }, [_c('el-input', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "id": task.LogTemplateTaskId
        },
        model: {
          value: (task.UserComment),
          callback: function($$v) {
            _vm.$set(task, "UserComment", $$v)
          },
          expression: "task.UserComment"
        }
      })], 1)])], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.templateForm.TemplateNotes[index].PoolId == item.PoolId),
        expression: "templateForm.TemplateNotes[index].PoolId == item.PoolId"
      }]
    }, [_c('label', {
      staticClass: "el-form-item__label col-xs-12",
      staticStyle: {
        "font-size": "14px",
        "color": "inherit!important"
      }
    }, [_vm._v("\r\n                              NOTES:\r\n                            ")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 5
      },
      model: {
        value: (_vm.templateForm.TemplateNotes[index].TaskNotes),
        callback: function($$v) {
          _vm.$set(_vm.templateForm.TemplateNotes[index], "TaskNotes", $$v)
        },
        expression: "templateForm.TemplateNotes[index].TaskNotes"
      }
    })], 1)], 1)], 2)], 1)])], 1)])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "inner_title_buttons"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.addRecord && _vm.addRecordbutton && !_vm.qid && (_vm.$hydrowareSecurityJS.canAdd_A('chemicalrecord'))) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddChemicalRecord('templateForm')
      }
    }
  }, [_vm._v("\r\n                Save\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.addRecord && !_vm.addRecordbutton && !_vm.qid && (_vm.$hydrowareSecurityJS.canEdit_A('chemicalrecord'))) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.UpdateChemicalRecord
    }
  }, [_vm._v("\r\n                Update\r\n              ")]) : _vm._e()]), _vm._v(" "), (_vm.isDashboardView) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rediectToDashboard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Dashboard ")])]) : _vm._e(), _vm._v(" "), (_vm.addRecord && !_vm.qid) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Log List")])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "AddChecklistModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('el-form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Select Aquatic Facility :"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select",
      "value-key": "LocationName"
    },
    on: {
      "change": function($event) {
        return _vm.ongetChecklist(_vm.cheklistLocation)
      }
    },
    model: {
      value: (_vm.cheklistLocation),
      callback: function($$v) {
        _vm.cheklistLocation = $$v
      },
      expression: "cheklistLocation"
    }
  }, _vm._l((_vm.Locations), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.LocationName,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Select Template:",
      "prop": "EvaluationTypeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select",
      "value-key": "Name"
    },
    model: {
      value: (_vm.checklistName),
      callback: function($$v) {
        _vm.checklistName = $$v
      },
      expression: "checklistName"
    }
  }, _vm._l((_vm.checklists), function(item) {
    return (item.IsActive) ? _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item
      }
    }) : _vm._e()
  }), 1)], 1)], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "color": "gray",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel\r\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.cheklistLocation || !_vm.checklistName
    },
    on: {
      "click": function($event) {
        return _vm.Proceed1(_vm.checklistName.Id)
      }
    }
  }, [_vm._v("Proceed\r\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Select Template")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e635107"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChemicalRecord/chemicalrecord.vue
// module id = 834
// module chunks = 1